<template>
  <div>
    <div>
      <v-layout>
        <page-title class="ml-4">Plans</page-title>
      </v-layout>

      <v-layout>
        <page-subtitle>
          Select a plan that fits your needs, upgrade at any time. Quotas will be shared among all projects in your account.
        </page-subtitle>
      </v-layout>

      <!-- Error message -->
      <v-layout>
        <div v-if="error">
          <v-alert type="error" dense outlined>
            {{ error }}
          </v-alert>
        </div>
      </v-layout>

      <v-layout class="mt-0">
        <div class="tbcard">
          <div>
            <v-layout row class="justify-center">
              <v-flex
                xs12
                md3
                lg3
                v-for="(plan, i) in billingPlans"
                :key="i"
                class="mt-5"
              >
                <v-card class="mx-auto mb-3 mr-3 ml-3" flat outlined>
                  <v-card-title class="headline">
                    {{ plan.name }}
                    <v-spacer></v-spacer> ${{ plan.price / 100}}/m
                  </v-card-title>
                  <v-card-text>
                    <p>
                      {{ plan.description }}
                    </p>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Resource
                            </th>
                            <th class="text-right">
                              Quota
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Projects</td>
                            <td class="text-right">
                              {{ plan.metadata.projects }}
                            </td>
                          </tr>
                          <tr>
                            <td>Devices</td>
                            <td class="text-right">
                              {{ plan.metadata.devices }}
                            </td>
                          </tr>
                          <tr>
                            <td>Applications</td>
                            <td class="text-right">
                              {{ plan.metadata.applications }}
                            </td>
                          </tr>
                          <tr>
                            <td>Secrets</td>
                            <td class="text-right">
                              {{ plan.metadata.secrets }}
                            </td>
                          </tr>
                          <tr>
                            <td>Device Monitors</td>
                            <td class="text-right">
                              {{ plan.metadata.monitors }}
                            </td>
                          </tr>
                          <tr>
                            <td>Team Members</td>
                            <td class="text-right">
                              {{ plan.metadata.members }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="primary--text mr-3"
                      outlined
                      :loading="loading"
                      :disabled="(updating || billingAccount && billingAccount.stripePlanId === plan.id ||
                       !billingAccount && plan.name === 'Free') ? true : false"
                      @click="selectPlan(plan)"
                    >                    
                      <!-- <v-icon class="mr-1">touch_app</v-icon> -->
                      <span v-if="billingAccount && billingAccount.stripePlanId === plan.id">
                        Current
                      </span>
                      <span v-else>
                        Select
                      </span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<style lang="stylus">
.tbcard {
  width: 100%;
  display: block;
}
</style>


<script>
import PageTitle from '../PageTitle';
import PageSubtitle from '../PageSubtitle';

export default {
  components: {
    PageTitle,
    PageSubtitle
  },

  data() {
    return {
      updating: false
    }
  },

  computed: {
    billingPlans() {
      return this.$store.state.billing.billingPlans
    },
    billingAccount() {
      return this.$store.state.billing.billingAccount
    },
    loading() {
      return this.$store.state.billing.loading
    },
    error() {
      return this.$store.state.billing.error
    }
  },

  mounted() {
    this.refresh()
  },

  methods: {
    async refresh() {
      this.$store.dispatch('ListBillingPlans')

      this.$store.dispatch('GetBillingAccount', {})      
    },
    async selectPlan(selectedPlan) {
      this.updating = true
      // This will either subscribe to a plan or will redirect us
      // to the Stripe checkout page
      await this.$store.dispatch('SubscribeToPlan', {
        billingAccountId: this.billingAccountId,
        planId: selectedPlan.id,
      })

      if (!this.error) {
        // Wait for 1.5 seconds and then call refresh() function,
        // we should have the webhook
        await sleep(1500)                
        await this.refresh()

        this.billingPlans.forEach(plan => {
          if (plan.id === selectedPlan.id) {
            this.$store.dispatch('Notify', `Subscribed to ${plan.name}`)
          }
        });
      }

      this.updating = false
    },
  }
}

// sleep time expects milliseconds
function sleep (time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
</script>
